module.exports = __webpack_public_path__ + "static/media/nip-download.a298760c.svg";